/* eslint-disable max-lines */ // BOOOOO!!!
import fetch from 'isomorphic-fetch'
import React, { Component, Fragment } from 'react'
import { fromJS, List, Map, OrderedMap } from 'immutable'
import cookie from 'react-cookies'

import Question from '@aytm/app/swidget/questions/components/_base'
import locale from '@aytm/app/swidget/questions/locale'

import LightBox from '@aytm/lib/rfd-ui/components/basic/light-box'

import drag, { processTouchEvent, resize } from '@aytm/lib/drag'

// styles
import style from '@aytm/app/swidget/questions/styles/sh.module.scss'
import shelfStyle from '@aytm/app/swidget/questions/styles/sh/shelf.module.scss'
import commonStyle from '@aytm/app/swidget/questions/styles/common.module.scss'

import ProductPopup from '@aytm/app/swidget/questions/components/sh/productPopup'
import EcommercePopup from '@aytm/app/swidget/questions/components/sh/ecommercePopup'
import Fridge from '@aytm/app/swidget/questions/components/sh/fridge'
import Shelves from '@aytm/app/swidget/questions/components/sh/shelves'
import Ecommerce from '@aytm/app/swidget/questions/components/sh/ecommerce'
import Cart from '@aytm/app/swidget/questions/components/sh/cart'

import { getFromArray, putToArray } from '@aytm/lib/common/array'
import scrollTo from '@aytm/lib/common/scroll'

import { SETTINGS } from '@aytm/app/swidget/questions/components/sh/settings'
import { stopEvent } from '@aytm/lib/common/func'
import { getImageAssetPath, IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT } from '@aytm/lib/common/assets'
import { hapticEffects } from '../../base/lib/hapticEffects'

import {
  getTotal,
  getSize,
  formatPrice,
  getMaxProductCount,
  getMaxPrice,
  imageRembg
} from '@aytm/app/swidget/questions/components/sh/functions'
import PropTypes from 'prop-types'
import Button from '@aytm/lib/rfd-ui/components/basic/button'
import ShelfFooter from '@aytm/app/swidget/questions/components/sh/FC/ShelfFooter'

const getDefaultImage = answer =>
  answer.get('gallery') != undefined
    ? (() => {
        const i = answer.get('gallery').findIndex(image => image.getIn(['product', 'default']))
        if (i < 0) return null
        return answer.getIn(['gallery', i])?.set('index', i) || null
      })()
    : null
// const isStatPage = document.querySelector('#stat-title') || document.querySelector('.print-controls')

const MAX_WIDGET_WIDTH = 1200

export class SHTheme extends Component {
  static propTypes = {
    accentColorRGB: PropTypes.object,
    accentColor: PropTypes.string,
    columns: PropTypes.number
  }

  shouldComponentUpdate(nextProps, _nextState) {
    return nextProps.accentColor !== this.currentAccentColor || nextProps.columns !== this.columns
  }

  render() {
    const accentColor = this.props.accentColor
    const columns = this.props.columns

    this.currentAccentColor = accentColor
    this.columns = columns

    return (
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html: `
          .swidget-sh-question-next-button:hover {
            background: ${accentColor};
            color: white;
          }
          .swidget-sh-question-next-button:hover i {
            color: white;
          }`
        }}
      />
    )
  }
  v
}

export default class Sh extends Question {
  constructor(props) {
    super(props)
    this.resizeToScreen = this.resizeToScreen.bind(this)
    this.fixScaleButtons = this.fixScaleButtons.bind(this)
    this.updateFullscreen = this.updateFullscreen.bind(this)
    this.scrollToLeft = this.scrollToLeft.bind(this)
    this.scrollToRight = this.scrollToRight.bind(this)
    this.onProductClick = this.onProductClick.bind(this)
    this.onHover = this.onHover.bind(this)
    this.showItemPopup = this.showItemPopup.bind(this)
    this.onPictureClick = this.onPictureClick.bind(this)
    this.animateCount = this.animateCount.bind(this)
    this.closeItemPopup = this.closeItemPopup.bind(this)
    this.addProductToCart = this.addProductToCart.bind(this)
    this.addToCart = this.addToCart.bind(this)
    this.clearCart = this.clearCart.bind(this)
    this.selectQTY = this.selectQTY.bind(this)
    this.deleteFromCart = this.deleteFromCart.bind(this)
    this.changeNA = this.changeNA.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.onScrollTouchStart = this.onScrollTouchStart.bind(this)
    this.onDragMove = this.onDragMove.bind(this)
    this.onScrollMouseDown = this.onScrollMouseDown.bind(this)
    this.renderScroll = this.renderScroll.bind(this)
    this.goNext = this.goNext.bind(this)
    this.renderNext = this.renderNext.bind(this)
    this.renderLongError = this.renderLongError.bind(this)
    this.renderError = this.renderError.bind(this)
    this.renderShelfError = this.renderShelfError.bind(this)
    this.showHideCart = this.showHideCart.bind(this)
    this.scrollToPosition = this.scrollToPosition.bind(this)
    this.updateScale = this.updateScale.bind(this)
    this.unsubscribeFromMove = this.unsubscribeFromMove.bind(this)
    this.unsubscribeFromDrag = this.unsubscribeFromDrag.bind(this)
    this.onMouseUp = this.onMouseUp.bind(this)
    this.onMouseDown = this.onMouseDown.bind(this)
    this.onTouchStart = this.onTouchStart.bind(this)
    this.getContainer = this.getContainer.bind(this)
    this.renderVerticalScroll = this.renderVerticalScroll.bind(this)
    this.renderHorizontalScroll = this.renderHorizontalScroll.bind(this)
    this.onVerticalScrollTouchStart = this.onVerticalScrollTouchStart.bind(this)
    this.onVerticalScrollMouseDown = this.onVerticalScrollMouseDown.bind(this)
    this.onHorizontalScrollTouchStart = this.onHorizontalScrollTouchStart.bind(this)
    this.onHorizontalScrollMouseDown = this.onHorizontalScrollMouseDown.bind(this)
    this.renderShelfContent = this.renderShelfContent.bind(this)
    this.showHideFullscreen = this.showHideFullscreen.bind(this)
    this.renderContent = this.renderContent.bind(this)
    this.renderDesktop = this.renderDesktop.bind(this)
    this.noApp = this.noApp.bind(this)
    this.yesApp = this.yesApp.bind(this)
    this.renderAppScreen = this.renderAppScreen.bind(this)
    this.renderMobile = this.renderMobile.bind(this)
    this.locale = locale(props.locale).get('questions')

    const { questionSchema, theme, innerWidth } = this.props

    this.takenGoods = []
    this.preTakenGoods = List()
    this.answersImages = {}
    this.touchMoveSubscription = null
    this.scrollSubscription = null
    this.dragSubscription = null
    this.isIos = document.createElement('a').relList.supports('ar')
    this.refScaleButtons = null

    this.answers = new OrderedMap(
      questionSchema.get('answers').map(v => [v.get('id'), v.set('currentPicture', getDefaultImage(v))])
    )

    this.shelvesSettings = {
      ...SETTINGS[questionSchema.get('store')][questionSchema.get('shelf_type')],
      ...questionSchema.get('shelf_config').toJS()
    }

    this.width = this.shelvesSettings.fridge ? 400 : 600

    if (questionSchema.get('store') != 'ecommerce') {
      this.realWidth = this.shelvesSettings.width
      this.widthFactor = questionSchema.getIn(['coordinates', 'widthFactor'])
        ? questionSchema.getIn(['coordinates', 'widthFactor'])
        : this.width / (this.shelvesSettings.width || 80)
      this.calculateSizes()
    }

    this.config =
      questionSchema.get('blocks_config') && questionSchema.get('blocks_config').size
        ? questionSchema.get('blocks_config')
        : List([
            Map({
              shelves: questionSchema.get('shelves_config'),
              width: this.shelvesSettings.width
            })
          ])

    this.shelfWidth = this.config.reduce((prev, cur) => prev + cur.get('width'), 0)

    this.widgetWidth = Math.max(props.width, questionSchema.getIn(['coordinates', 'imageWidth']))
    // Rendered pallet content is 10px*(sections-2) narrower than widgetWidth (section overlap vs holders residual).
    // Use this for the container and scroll math so nothing over-scrolls into the trailing gap (AYTM-12775).
    this.contentWidth =
      this.widgetWidth - 10 * Math.max(0, Math.min(3, questionSchema.get('pallet_sections_count') || 1) - 2)
    this.widgetHeight = questionSchema.getIn(['coordinates', 'imageHeight'])
    this.verticalScrolling = 'smooth' == this.shelvesSettings.expand //'mobile' == props.theme || questionSchema.get('fullscreen') // questionSchema.getIn(['coordinates', 'imageHeight']) >= window.innerHeight

    // pallet has discrete expand but, like smooth, can be wider than the viewport (multi-section) and needs the
    // desktop fullscreen horizontal scroll (AYTM-12775).
    const scrollableExpand = 'smooth' == this.shelvesSettings.expand || 'pallet' == questionSchema.get('shelf_type')
    this.renderScrolling =
      this.widgetWidth >= innerWidth && questionSchema.get('fullscreen') && props.theme != 'mobile' && scrollableExpand
    this.horizontalScrolling = !this.renderScrolling && scrollableExpand
    this.generateImage = Boolean(props.generateImageHook) || Boolean(props.generateImage)
    this.maxWidth = questionSchema.get('fullscreen') && !this.generateImage ? window.innerWidth : MAX_WIDGET_WIDTH

    // this.maxWidth = this.generateImage ? 10000 : questionSchema.get('fullscreen') ? innerWidth : MAX_WIDGET_WIDTH

    if (this.generateImage && !window['AYTM_shelfImage_' + questionSchema.get('id')]?.src) {
      if (this.widgetWidth > this.maxWidth) {
        window['AYTM_shelfScale_' + questionSchema.get('id')] = this.widgetWidth / this.maxWidth
        window['AYTM_shelfMargin_' + questionSchema.get('id')] = (this.widgetWidth - this.maxWidth) / 2
      }
      window['AYTM_shelfImage_' + questionSchema.get('id')] = {
        width: this.widgetWidth / window['AYTM_shelfScale_' + questionSchema.get('id')]
      }
    }

    this.animateLayers =
      ((this.widgetWidth >= innerWidth && questionSchema.get('fullscreen')) ||
        (!questionSchema.get('fullscreen') && this.widgetWidth > MAX_WIDGET_WIDTH)) &&
      // props.theme != 'mobile' &&
      'smooth' == this.shelvesSettings.expand

    if (theme != 'mobile')
      this.props.onWidthChanged(questionSchema.get('fullscreen') ? 600 : Math.min(this.maxWidth, this.widgetWidth))
    this.scrollPercent = 0

    this.state = {
      ...this.state,
      selectedItem: null,
      selectedGood: null,
      selectedCount: 1,
      cartCount: 0,
      cartTotal: 0,
      na: false,
      fullError: false,
      showCart: false,
      valid: false,
      x: 0,
      y: 0,
      scale: 1,
      titleHeight: 0,
      goods: this.preTakenGoods,
      windowWidth: innerWidth,
      closeFullscreen: false,
      dontWantToApp: false,
      hover: false
    }

    this.i = 0
    this.vx = 0
    this.vy = 0

    this.findability =
      'find' == questionSchema.get('mode_type') ||
      (1 == questionSchema.get('max_cart_size') && !questionSchema.get('shopping_cart'))

    this.cleanAnswer = Map({
      clicked: 0,
      left:
        !(
          this.widgetWidth >= window.innerWidth &&
          questionSchema.get('fullscreen') &&
          questionSchema.get('force_scroll')
        ) || this.findability,
      right:
        !(
          this.widgetWidth >= window.innerWidth &&
          questionSchema.get('fullscreen') &&
          questionSchema.get('force_scroll')
        ) || this.findability,
      answers: this.answers.map(answer =>
        OrderedMap({ id: answer.get('id'), item: answer, count: 0, na: answer.get('na') })
      )
    })
    this.handScale =
      questionSchema.get('zoom') &&
      'mobile' != props.theme &&
      questionSchema.get('store') != 'ecommerce' &&
      !this.generateImage
    this.backupAnswer = this.cleanAnswer
    this.initAnswer(this.cleanAnswer)
    this.escFunction = event => {
      if ('Escape' === event.key) {
        stopEvent(event)
        this.closeItemPopup()
      }
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount()
    document.removeEventListener('keydown', this.escFunction, false)
    if (this.interval) clearInterval(this.interval)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    super.UNSAFE_componentWillReceiveProps(nextProps)
    if (nextProps.width != this.props.width) {
      // this.widgetWidth = Math.max(nextProps.width, nextProps.questionSchema.getIn(['coordinates', 'imageWidth']))
      this.maxWidth = this.generateImage
        ? 10000
        : nextProps.questionSchema.get('fullscreen')
          ? nextProps.innerWidth
          : MAX_WIDGET_WIDTH
      this.resizeToScreen()
      this.updateScale(1)
    }
  }

  componentDidMount() {
    super.componentDidMount()
    const { questionSchema } = this.props
    this.resizeToScreen()
    this.onScroll()
    // setTimeout(() => {
    //   if (
    //     'mobile' == self.props.theme &&
    //     self.refShelvesRef &&
    //     self.refShelvesRef &&
    //     self.refShelvesRef.scrollWidth > 1.1 * self.refShelvesRef.offsetWidth
    //   ) {
    //     scrollTo(self.refShelvesRef, { left: self.refShelvesRef.scrollWidth, duration: 2400 })
    //       .then(() => {
    //         setTimeout(() => {
    //           scrollTo(self.refShelvesRef, {
    //             left: (self.refShelvesRef.scrollWidth - self.refShelvesRef.offsetWidth) / 3 - 10,
    //             duration: 1200
    //           })
    //         }, 800)
    //       })
    //       .catch(() => {})
    //   }
    // }, 2000)
    if (questionSchema.get('fullscreen'))
      setTimeout(() => {
        this.setState({ titleHeight: this.refTitle?.clientHeight })
      }, 1000)
    if (questionSchema.get('fullscreen')) window.addEventListener('resize', this.updateFullscreen)
    if (this.handScale) window.addEventListener('scroll', this.fixScaleButtons)
  }

  resizeToScreen() {
    const { theme, innerWidth, inApp } = this.props
    const goalScale = this.widgetWidth > innerWidth ? Math.max(0.5, innerWidth / this.widgetWidth) : 1
    if ('mobile' == theme && !inApp)
      setTimeout(() => {
        const resize = newScale => {
          if (newScale > goalScale) {
            this.updateScale(newScale)
            setTimeout(() => resize(newScale - 0.02 < goalScale ? goalScale : newScale - 0.02), 50)
          } else this.updateScale(goalScale)
        }
        setTimeout(() => resize(1), 500)
      }, 1000)
    if ('mobile' == theme && inApp) this.updateScale(goalScale)
  }

  fixScaleButtons() {
    if (this.refScaleButtons && this.refShelvesRef) {
      const rectShelves = this.refShelvesRef.getBoundingClientRect()
      const rectButtons = this.refScaleButtons.getBoundingClientRect()
      if (rectShelves.y < 20) {
        this.refScaleButtons.style.position = 'fixed'
        this.refScaleButtons.style.left = rectButtons.x + 'px'
        this.refScaleButtons.style.right = 'auto'
        this.refScaleButtons.style.top = '300px'
      }
      // } else {
      //   this.refScaleButtons.style.position = 'absolute'
      //   this.refScaleButtons.style.left = 'auto'
      //   this.refScaleButtons.style.right = '-60px'
      //   this.refScaleButtons.style.top = '320px'
      // }
    }
  }

  updateFullscreen() {
    this.setState({ windowWidth: window.innerWidth })
  }

  waitForSmallImages(props) {
    const self = this
    const { questionSchema, theme } = this.props
    const paths = props.questionSchema.get('answers').reduce((prev, answer) => {
      const maxSize = Math.max(answer.get('width'), answer.get('height')) * 10
      const imageSize = maxSize > 150 ? (maxSize > 300 ? 600 : 300) : 300
      const mainRembg = imageRembg(answer.get('image'), answer)
      const withPicture =
        answer.get('image') && answer.getIn(['image', 'original_path'])
          ? prev.push({
              url: getImageAssetPath({
                filter: IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT,
                width: imageSize,
                height: imageSize,
                path: answer.getIn(['image', 'original_path']),
                backgroundColor: 'transparent',
                trim: true,
                json: true,
                rembg: mainRembg,
                padratio: mainRembg,
                padratio_width: mainRembg ? answer.getIn(['image', 'trimmed_image', 'width']) : 0,
                padratio_height: mainRembg ? answer.getIn(['image', 'trimmed_image', 'height']) : 0
              }),
              answerId: answer.get('id')
            })
          : prev
      const topImage =
        answer.get('gallery') && answer.get('gallery').find(image => 'single' == image.getIn(['product', 'image_type']))
      const topRembg = imageRembg(topImage, answer)
      return topImage
        ? withPicture.push({
            url: getImageAssetPath({
              filter: IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT,
              width: 600,
              height: 600,
              path: topImage.get('original_path'),
              backgroundColor: 'transparent',
              animated: true,
              trim: true,
              json: true,
              rembg: topRembg,
              padratio: topRembg,
              padratio_width: topRembg ? answer.getIn(['image', 'trimmed_image', 'width']) : 0,
              padratio_height: topRembg ? answer.getIn(['image', 'trimmed_image', 'height']) : 0
            }),
            answerId: answer.get('id') + '_top'
          })
        : withPicture
    }, List())

    Promise.all(
      paths.map(
        path =>
          new Promise(resolve => {
            if (!path.url) resolve(path)
            fetch(path.url, {
              method: 'GET',
              mode: window.aytmNoCorsSecret ? 'no-cors' : 'cors'
            })
              .then(resp => resp.json())
              .then(resp => {
                if (resp.url) {
                  const img = new Image()
                  img.crossOrigin = ''
                  img.src = resp.url
                  img.onload = () => {
                    self.answersImages[path.answerId] = img
                    if ('function' === typeof self.props.onRender) self.props.onRender()
                    resolve(path)
                  }
                  img.onerror = () => {
                    resolve(path)
                  }
                }
              })
              .catch(() => resolve(path))
          })
      )
    ).then(() => {
      if (theme != 'mobile')
        this.props.onWidthChanged(
          questionSchema.get('fullscreen') && theme != 'mobile' && !this.generateImage
            ? 600
            : Math.min(this.maxWidth, this.widgetWidth)
        )
      setTimeout(() => {
        this.setState({ smallImagesReady: true })
        if (
          self.refShelvesRef &&
          questionSchema.get('fullscreen') &&
          questionSchema.get('scroll_start') &&
          questionSchema.get('scroll_start') !== 'left' &&
          self.widgetWidth > self.maxWidth
        ) {
          scrollTo(self.refShelvesRef, {
            left: ((position, width) => {
              if (position !== 'random') return width / ('right' === position ? 1 : 2)
              const x = Math.random()
              if (questionSchema.get('fullscreen'))
                self.updateTimeline({
                  type: 'scrolling_start',
                  target: x > 0.33 ? (x < 0.66 ? 'center' : 'right') : 'left'
                })
              return width * x
            })(questionSchema.get('scroll_start'), self.refShelvesRef.scrollWidth - window.innerWidth),
            duration: 1
          })
          if (self.state.answer) self.updateAnswer(self.state.answer.update('left', () => false))
        }

        // 3-section pallet is wider than the viewport — start scrolled to the middle section,
        // unless an explicit (non-left) scroll_start already positioned it above.
        const palletSectionsCount = Math.max(1, Math.min(3, questionSchema.get('pallet_sections_count') || 1))
        const noExplicitStart = !questionSchema.get('scroll_start') || 'left' === questionSchema.get('scroll_start')
        if (palletSectionsCount === 3 && noExplicitStart && self.refShelvesRef) {
          const maxScroll = self.refShelvesRef.scrollWidth - self.refShelvesRef.clientWidth
          if (maxScroll > 0) scrollTo(self.refShelvesRef, { left: maxScroll / 2, duration: 1 })
        }

        if ('function' === typeof props.afterImage) props.afterImage()
        this.animateScroll()
      }, 10)
    })
  }

  scrollToLeft() {
    if (this.refShelvesRef)
      scrollTo(this.refShelvesRef, {
        left: this.refShelvesRef?.scrollLeft - this.refShelvesRef?.scrollWidth / 10,
        duration: 500
      }).catch(() => {})
  }

  scrollToRight() {
    if (this.refShelvesRef)
      scrollTo(this.refShelvesRef, {
        left: this.refShelvesRef?.scrollLeft + this.refShelvesRef?.scrollWidth / 10,
        duration: 500
      }).catch(() => {})
  }

  animateScroll() {
    const { theme } = this.props
    const self = this
    if (this.refShelvesRef && this.refScaleButtons) {
      const rectShelves = this.refShelvesRef.getBoundingClientRect()
      this.refScaleButtons.style.left = Math.min(rectShelves.x + rectShelves.width + 100, innerWidth - 30) + 'px'
      this.refScaleButtons.style.right = 'auto'
      this.refScaleButtons.style.display = 'inline-block'
    }
    if (this.refShelvesRef && (this.renderScrolling || 'mobile' == theme)) {
      const x =
        'mobile' == theme
          ? self.refShelvesRef.scrollWidth - window.innerWidth
          : (self.refShelvesRef.scrollWidth - window.innerWidth) / 2

      if (window.innerHeight - 162 < this.refShelvesRef.offsetHeight && this.refLinks) {
        this.refLinks.style.position = 'fixed'
        this.refFooter.style.position = 'fixed'
        // this.refLightBox.refLightBoxBackdrop.style.height =
        //   this.refLightBox.refLightBoxBackdrop.clientHeight - 90 + 'px'
      }
      setTimeout(() => {
        if ('mobile' == theme && this.refShelvesRef && this.refShelvesRef.scrollWidth - innerWidth < 30)
          this.stopScrolling = true
        if (self.refShelvesRef && !this.stopScrolling)
          scrollTo(self.refShelvesRef, { left: x, duration: 20 * x })
            .then(() => {
              setTimeout(() => {
                if (self.refShelvesRef && !this.stopScrolling)
                  scrollTo(self.refShelvesRef, {
                    left: x / 2,
                    duration: 20 * x
                  })
                    .then(() => {
                      setTimeout(() => {
                        if (self.refShelvesRef && !this.stopScrolling)
                          scrollTo(self.refShelvesRef, { left: x, duration: 20 * x }).catch(() => {})
                      }, 200)
                    })
                    .catch(() => {})
              }, 400)
            })
            .catch(() => {})
      }, 4000)
    }

    // setTimeout(() => {
    //   this.refShelvesRef.scroll({ left: x - 100, behavior: 'smooth' })
    //   setTimeout(() => {
    //     this.refShelvesRef.scroll({ left: x - 20, behavior: 'smooth' })
    //   }, 500)
    // }, 1000)
  }

  validate(answerModel) {
    const { questionSchema } = this.props
    const total = getTotal(answerModel)
    const size = getSize(answerModel)
    const hasPurchasableProducts = questionSchema.get('answers_mask').some(shelf =>
      shelf.some(
        product =>
          questionSchema
            .get('answers')
            .find(answer => answer.get('id') === product.get(0))
            ?.get('available') === true
      )
    )

    const valid =
      (!questionSchema.get('na') && !hasPurchasableProducts) ||
      ((!questionSchema.get('na') ? answerModel.get('clicked') : size > 0) &&
        (!questionSchema.get('max_qty_per_product') ||
          this.findability ||
          questionSchema.get('max_qty_per_product') >=
            answerModel.get('answers').reduce((max, c) => Math.max(max, c.get('count')), 0)) &&
        (!questionSchema.get('max_money_spent') ||
          total <= questionSchema.get('max_money_spent') ||
          this.findability) &&
        (!questionSchema.get('max_cart_size') || size <= questionSchema.get('max_cart_size') || this.findability) &&
        ((answerModel.get('left') && answerModel.get('right')) || !questionSchema.get('force_scroll')))
    this.setState({ valid: valid })

    return Map({
      valid: valid
    })
  }

  backendResponse(answerModel) {
    return answerModel.get('answers')
      ? answerModel
          .get('answers')
          .filter(item => item.get('count') > 0)
          .map(item => {
            return { id: item.get('id'), v: item.get('count') }
          })
          .toArray()
      : []
  }

  calculateSizes() {
    const { questionSchema, theme, generateImageHook } = this.props
    this.answers = this.answers.withMutations(answers =>
      answers.forEach(answer =>
        answers
          .setIn(
            [answer.get('id'), 'height'],
            Math.round(this.widthFactor * answer.get('height') * this.shelvesSettings.widthCoef)
          )
          .setIn(
            [answer.get('id'), 'width'],
            Math.round(this.widthFactor * answer.get('width') * this.shelvesSettings.widthCoef)
          )
          .setIn(
            [answer.get('id'), 'offset_y'],
            Math.round(this.widthFactor * answer.get('offset_y') * this.shelvesSettings.widthCoef)
          )
      )
    )

    this.shelvesWidth = this.shelvesSettings.fridge
      ? (470 + this.shelvesSettings.walls * this.widthFactor) * (questionSchema.get('double_width') ? 2 : 1)
      : Math.round(this.widthFactor * this.realWidth)
    if (this.realWidth != this.shelvesSettings.width && theme != 'mobile') {
      this.props.onWidthChanged(Math.min(this.maxWidth, this.shelvesWidth))
    }

    const stock = questionSchema.get('stock_type')
    const prob =
      'full' === stock || 'no' == stock || this.generateImage || generateImageHook ? 0 : 'typical' == stock ? 20 : 40
    if (prob)
      questionSchema.get('answers_mask').forEach((shelf, shelfIndex) => {
        shelf.forEach((items, itemsIndex) => {
          let taken = 0
          if (items.get(1) > 1)
            for (let i = 0; i < items.get(1) - 1; i++) {
              if (Math.random() * 100 < (this.shelvesSettings.double ? 5 * prob : prob)) {
                putToArray(this.takenGoods, [shelfIndex, itemsIndex, i, 0], true)
                if (Math.random() * 100 < (this.shelvesSettings.double ? 2 * prob : prob)) {
                  putToArray(this.takenGoods, [shelfIndex, itemsIndex, i, 1], true)
                }
                if (Math.random() * 100 < 2 * prob && this.shelvesSettings.double && items.get(1) > taken + 1) {
                  taken += 1
                  putToArray(this.takenGoods, [shelfIndex, itemsIndex, i, 2], true)
                }
              }
              if (this.shelvesSettings.double || 'counterFridge' == this.shelvesSettings.styleClass) {
                let taken = 0
                for (let i = 0; i < items.get(1); i++) {
                  if (getFromArray(this.takenGoods, [shelfIndex, itemsIndex, i, 0]) && Math.random() * 100 < 3 * prob) {
                    putToArray(this.takenGoods, [shelfIndex, itemsIndex, i, this.shelvesSettings.deep], true)
                    if (
                      getFromArray(this.takenGoods, [shelfIndex, itemsIndex, i, this.shelvesSettings.deep]) &&
                      getFromArray(this.takenGoods, [shelfIndex, itemsIndex, i, 1]) &&
                      Math.random() * 100 < 2 * prob
                    ) {
                      putToArray(this.takenGoods, [shelfIndex, itemsIndex, i, this.shelvesSettings.deep + 1], true)
                      if (
                        getFromArray(this.takenGoods, [shelfIndex, itemsIndex, i, this.shelvesSettings.deep + 1]) &&
                        getFromArray(this.takenGoods, [shelfIndex, itemsIndex, i, 2]) &&
                        Math.random() * 100 < 2 * prob &&
                        taken < items.get(1) - 2
                      ) {
                        putToArray(this.takenGoods, [shelfIndex, itemsIndex, i, this.shelvesSettings.deep + 2], true)
                        taken += 1
                      }
                    }
                  }
                }
              }
            }
        })
      })
    this.preTakenGoods = fromJS(this.takenGoods)
  }

  onProductClick(item, number, callback, coords) {
    if (number) this.setState({ selectedGood: number })
    this.showItemPopup(item, coords)
    hapticEffects.selection()
    this.callback = callback
  }

  onHover(hovered) {
    this.setState({ hover: hovered })
  }

  showItemPopup(item, coords) {
    // const { theme, preview } = this.props
    const { answer } = this.state
    if (this.dragging) {
      this.dragging = false
      return
    }
    this.setState({ selectedItem: item })

    const timeline = this.updateTimeline({
      type: 'open_popup',
      ref: item.get('id'),
      target: coords
    })
    const newAnswer = answer.update('clicked', value => value + 1)
    this.updateAnswer(newAnswer, timeline)
    this.stopScrolling = true

    this.scrollToPosition()
    document.addEventListener('keydown', this.escFunction, false)
  }

  onPictureClick(number) {
    const { selectedItem } = this.state
    this.updateTimeline({
      type: 'product_picture_click',
      ref: selectedItem.get('id'),
      target: number ? number.toString() : ''
    })
  }

  animateCount(newAnswer) {
    const { answer, cartCount } = this.state
    if (!newAnswer) return
    const newCount = (newAnswer || answer).get('answers').reduce((prev, cur) => cur.get('count') + prev, 0)
    const newTotal = getTotal(newAnswer || answer)
    // this.setState({
    //   countChanged: newCount != cartCount
    // })

    if (newCount != cartCount) {
      setTimeout(() => {
        this.setState({ cartCount: newCount, cartTotal: newTotal })
      }, 50)
      // setTimeout(() => {
      //   this.setState({ countChanged: false })
      // }, 600)
    }
  }

  closeItemPopup(newAnswer) {
    const { selectedItem } = this.state
    document.removeEventListener('keydown', this.escFunction, false)

    if (selectedItem) {
      this.updateTimeline({
        type: 'close_popup',
        ref: selectedItem.get('id')
      })

      this.setState({
        selectedItem: null,
        selectedCount: 1,
        selectedGood: null
      })
      this.animateCount(newAnswer)
    }
  }

  addProductToCart(item, qty) {
    this.setState({ selectedItem: item }, () => this.addToCart(qty))
  }

  addToCart(qty) {
    const { selectedItem, answer, selectedGood } = this.state
    const { questionSchema, goNext } = this.props

    if (questionSchema.get('store') != 'ecommerce' && selectedGood) {
      putToArray(this.takenGoods, selectedGood, true)
      this.setState({ goods: fromJS(this.takenGoods) })
    }
    const timeline = this.updateTimeline({
      type: 'add_to_cart',
      ref: selectedItem.get('id'),
      target: qty.toString()
    })
    const newAnswer = answer.updateIn(['answers', selectedItem.get('id'), 'count'], value => value + qty || 0)
    this.updateAnswer(newAnswer, timeline)
    this.closeItemPopup(newAnswer)
    hapticEffects.selection()
    if ('function' == typeof this.callback) this.callback()
    if ('function' == typeof goNext && this.findability)
      setTimeout(() => {
        goNext()
      }, 200)
  }

  clearCart() {
    const { answer } = this.state
    const timeline = this.updateTimeline({
      type: 'clear_cart'
    })
    const newAnswer = answer.update('answers', value => value.map(a => a.set('count', 0)))
    this.updateAnswer(newAnswer, timeline)
    this.setState({ fullError: false, goods: this.preTakenGoods })
    this.takenGoods = this.preTakenGoods.toJS()
    this.animateCount(newAnswer)
  }

  selectQTY(qty, item) {
    const { selectedItem } = this.state
    const timeline = this.updateTimeline({
      type: 'edit_in_cart',
      ref: item ? item.get('id') : selectedItem.get('id'),
      target: qty.get('value').toString()
    })
    if (item) {
      const { answer } = this.state
      const newAnswer = answer.setIn(['answers', item.get('id'), 'count'], qty.get('value'))
      this.updateAnswer(newAnswer, timeline)
      this.animateCount(newAnswer)
    } else this.setState({ selectedCount: qty.get('value') })
  }

  deleteFromCart(item) {
    const { answer } = this.state
    const timeline = this.updateTimeline({
      type: 'delete_from_cart',
      ref: item.get('id')
    })
    const newAnswer = answer.setIn(['answers', item.get('id'), 'count'], 0)
    this.updateAnswer(newAnswer, timeline)
    this.animateCount(newAnswer)
  }

  changeNA() {
    const { na, answer } = this.state
    const timeline = this.updateTimeline({
      type: na ? 'no_na' : 'na'
    })

    if (na) {
      this.updateAnswer(this.backupAnswer, timeline)
      this.animateCount(this.backupAnswer)
      this.backupAnswer = this.cleanAnswer
    } else {
      const clickedCleanAnswer = this.cleanAnswer.set('clicked', 1).set('left', true).set('right', true)
      const naAnswer = this.answers.find(answer => answer.get('na'))
      this.backupAnswer = answer
      hapticEffects.selection()
      if (naAnswer) this.updateAnswer(clickedCleanAnswer.setIn(['answers', naAnswer.get('id'), 'count'], 1))
    }
    this.setState({ fullError: false, goods: this.preTakenGoods })
    this.takenGoods = this.preTakenGoods.toJS()
    this.setState({ na: !na, cartCount: 0 })
  }

  onScroll() {
    const { showCart, scale, answer } = this.state
    const { theme } = this.props
    if (this.refShelvesRef) {
      this.scrollPercent = this.refShelvesRef?.scrollLeft / (this.contentWidth * scale - this.refShelvesRef.offsetWidth)
      this.verticalScrollPercent =
        this.refShelvesRef?.scrollTop / ((40 + this.widgetHeight) * scale - this.refShelvesRef.clientHeight)
      this.horizontalScrollPercent =
        this.refShelvesRef?.scrollLeft / (this.contentWidth * scale - this.refShelvesRef.offsetWidth)
      if (this.contentWidth * scale <= 1.05 * this.refShelvesRef.offsetWidth) {
        this.updateAnswer(answer.update('left', () => true))
        this.updateAnswer(answer.update('right', () => true))
      }
    }

    if (
      this.widgetWidth >= this.maxWidth &&
      !showCart &&
      this.refShelvesRef &&
      theme != 'mobile' &&
      this.refScrollPointer
    ) {
      this.refScrollPointer.style.left =
        this.scrollPercent * (this.refScrollDiv.clientWidth - this.refScrollPointer.clientWidth) + 'px'
      this.refLeftShadow.style.opacity = this.scrollPercent
      this.refRightShadow.style.opacity = 1 - this.scrollPercent
    }
    // else {
    //   if (this.refLeftArrow) this.refLeftArrow.style.opacity = this.scrollPercent
    //   if (this.refRightArrow) this.refRightArrow.style.opacity = 1 - this.scrollPercent
    // }

    if (
      this.refVerticalScrollDiv &&
      this.widgetHeight * scale >= this.refVerticalScrollDiv.clientHeight &&
      this.refShelvesRef &&
      this.verticalScrollPercent &&
      this.refVerticalScrollPointer
    ) {
      this.refVerticalScrollPointer.style.top =
        Math.max(0, this.verticalScrollPercent * (94 - this.refVerticalScrollPointer.clientHeight)) + 7 + 'px'
    }

    if (
      this.refHorizontalScrollDiv &&
      this.contentWidth * scale >= this.refHorizontalScrollDiv.clientWidth &&
      this.refShelvesRef &&
      // 'mobile' == theme &&
      this.refHorizontalScrollPointer
    ) {
      this.refHorizontalScrollPointer.style.left =
        Math.max(0, this.horizontalScrollPercent * (94 - this.refHorizontalScrollPointer.clientWidth)) + 7 + 'px'
    }

    if (this.scrollPercent < 0.05 && !answer.get('left')) this.updateAnswer(answer.update('left', () => true))
    if (this.scrollPercent > 0.95 && !answer.get('right')) this.updateAnswer(answer.update('right', () => true))
  }

  onScrollTouchStart(event) {
    return 1 == event.touches.length ? this.onScrollMouseDown(processTouchEvent(event)) : false
  }

  calculateScrolling(dragUpdate) {
    const { showCart, scale } = this.state
    const { theme } = this.props

    if (!showCart && theme != 'mobile' && this.refShelvesRef) {
      const x = dragUpdate
        ? Math.min(
            this.refScrollDiv.clientWidth - this.refScrollPointer.clientWidth / 2,
            dragUpdate.x - this.refScrollPointer.clientWidth / 2
          )
        : this.refScrollDiv.clientWidth * Math.random()
      this.scrollPercent = x / (this.refScrollDiv.clientWidth - this.refScrollPointer.clientWidth)
      this.refShelvesRef.scrollLeft = this.scrollPercent * (this.contentWidth * scale - this.refShelvesRef.offsetWidth)
    }
    // this.refScrollPointer.style.left =
    //   this.scrollPercent * (this.refScrollDiv.clientWidth - this.refScrollPointer.clientWidth) + 'px'
  }

  onDragMove(dragUpdate) {
    this.calculateScrolling(dragUpdate)
  }

  onScrollMouseDown(event) {
    const targetX = this.refScrollPointer.offsetLeft + this.refScrollPointer.offsetWidth / 2
    const targetY = this.refScrollPointer.offsetTop + this.refScrollPointer.offsetHeight / 2
    this.scrollSubscription = drag(event, targetX, targetY).subscribe(dragUpdate => {
      this.onDragMove(dragUpdate)
      if (!dragUpdate.dragging) {
        this.onDragEnd && this.onDragEnd()
      }
    })
  }

  renderScroll() {
    const { questionSchema } = this.props
    const { na } = this.state
    return (
      <div
        className={style.scrollDiv}
        ref={this.saveRef('ScrollDiv')}
        data-testid="SW-SH-Scroll"
        style={{
          width: questionSchema.get('shopping_cart') ? '90%' : '100%',
          display: na ? 'none' : 'block'
        }}
      >
        <div className={style.scrollBg} />
        <div
          className={style.scroll}
          ref={this.saveRef('ScrollPointer')}
          style={{
            width: (this.maxWidth / this.widgetWidth) * 100 + '%',
            right: 'auto'
          }}
        >
          <div
            className={style.scrollCircle}
            data-testid="SW-SH-ScrollEl"
            onTouchStart={this.onScrollTouchStart}
            onMouseDown={this.onScrollMouseDown}
          >
            <i className="icon-aytmfd-qshelf-man"></i>
          </div>
        </div>
      </div>
    )
  }

  goNext() {
    setTimeout(() => {
      this.props.goNext()
    }, 200)
  }

  renderNext() {
    const { previewMode } = this.props
    const { valid } = this.state
    return (
      <div
        className={` ${style.next}  ${valid || 'xrays' == previewMode ? '' : style.disabled}`}
        onClick={this.goNext}
        data-testid="SW-SH-FSNext"
      >
        {this.locale.getIn(['sh', 'next'])}
        <i className="icon-aytmfd-new-next"></i>
      </div>
    )
  }

  renderLongError() {
    const { questionSchema, previewMode, theme } = this.props
    return (
      <Fragment>
        {theme != 'mobile' &&
          !questionSchema.get('fullscreen') &&
          this.widgetWidth > MAX_WIDGET_WIDTH &&
          questionSchema.get('preview') &&
          previewMode && (
            <div className={style.errorBlock} data-testid="SW-SH-Error-Length">
              <span>{this.locale.getIn(['sh', 'shelfError_longWidget'])}</span>
            </div>
          )}
      </Fragment>
    )
  }

  renderError() {
    const { questionSchema } = this.props
    const { answer } = this.state

    if (
      !(
        questionSchema.get('min_qty') ||
        questionSchema.get('max_cart_size') ||
        questionSchema.get('max_qty_per_product') ||
        questionSchema.get('max_money_spent') ||
        (questionSchema.get('fullscreen') && questionSchema.get('force_scroll'))
      )
    )
      return ''

    if (this.findability) return ''
    const cartSize = getSize(answer)
    const cartPrice = getTotal(answer)
    const cartProductCount = getMaxProductCount(answer)
    const maxPrice = getMaxPrice(answer)

    const error =
      (!questionSchema.get('min_qty') || questionSchema.get('min_qty') <= cartSize
        ? ''
        : this.locale.getIn(['sh', 'emptyCartError'])(questionSchema.get('min_qty')) + '  ') +
      (!questionSchema.get('max_cart_size') || questionSchema.get('max_cart_size') > cartSize
        ? ''
        : this.locale.getIn(['sh', 'maxCartCountError'])(questionSchema.get('max_cart_size')) + '  ') +
      (!questionSchema.get('max_money_spent') || questionSchema.get('max_money_spent') >= cartPrice + maxPrice
        ? ''
        : this.locale.getIn(['sh', 'maxSpentError'])(
            formatPrice(questionSchema.get('max_money_spent'), questionSchema.get('price_mask'))
          ) + '  ') +
      (!questionSchema.get('max_qty_per_product') || questionSchema.get('max_qty_per_product') > cartProductCount
        ? ''
        : this.locale.getIn(['sh', 'maxProductCountError'])(questionSchema.get('max_qty_per_product')) + '  ')

    const scrollError =
      questionSchema.get('fullscreen') &&
      questionSchema.get('force_scroll') &&
      (!answer.get('left') || !answer.get('right'))
        ? this.locale.getIn(['sh', 'scrollError'])
        : ''

    return (
      <>
        {(error || scrollError) && (
          <div className={style.errorBlock}>
            <span dangerouslySetInnerHTML={{ __html: error + ' ' + scrollError }} />
          </div>
        )}
      </>
    )
  }

  renderShelfError(key) {
    const { questionSchema, previewMode } = this.props

    return previewMode && previewMode !== 'respondent' ? (
      <div className={style.errorBlock} key={key} data-testid="SW-SH-Error-Size">
        <span
          dangerouslySetInnerHTML={{
            __html:
              this.locale.getIn(['sh', previewMode + 'Warning']) +
              (('airCurtainFridge' == questionSchema.get('shelf_type') ||
                'displayFridge' == questionSchema.get('shelf_type') ||
                'pallet' == questionSchema.get('shelf_type') ||
                questionSchema.get('fullscreen')) &&
              this.locale.getIn(['sh', 'shelfError_' + key + '_fullscreen'])
                ? this.locale.getIn(['sh', 'shelfError_' + key + '_fullscreen'])
                : this.locale.getIn(['sh', 'shelfError_' + key]))
          }}
        />
      </div>
    ) : (
      ''
    )
  }

  showHideCart() {
    const { selectedItem, showCart, scale } = this.state
    const { theme } = this.props
    const timeline = selectedItem
      ? this.updateTimeline({
          type: 'close_popup',
          ref: selectedItem.get('id')
        })
      : this.state.timeline
    this.updateTimeline(
      {
        type: showCart ? 'close_cart' : 'open_cart'
      },
      timeline
    )

    if (scale > 1 && this.handScale) {
      if (!showCart) {
        this.scrollLeft = this.refShelvesRef.scrollLeft
        this.scrollTop = this.refShelvesRef.scrollTop
      } else {
        this.scrollToPosition(true)
      }
    }
    this.setState({ showCart: !showCart, selectedItem: null })
    if (showCart && 'mobile' == theme) {
      this.setState({ hideContent: true })
      setTimeout(() => {
        const { scale } = this.state
        this.updateScale(scale)
        this.setState({ hideContent: false })
      }, 500)
    }
  }

  scrollToPosition(reset) {
    const { scale } = this.state
    if (scale > 0 && this.handScale && (this.scrollLeft || this.scrollTop)) {
      const scrollInterval = setInterval(() => {
        if (this.refShelvesRef) {
          this.refShelvesRef.scrollTo(this.scrollLeft, this.scrollTop)
          if (reset) {
            this.scrollLeft = 0
            this.scrollTop = 0
          }
          clearInterval(scrollInterval)
        }
      }, 10)
    }
  }

  updateScale(newScale) {
    const { theme } = this.props
    const { answer, scale } = this.state
    if ('mobile' == theme && newScale < 0.5) return
    const scaleDiff = newScale / scale
    if (this.refShelvesRef) {
      if (!this.originalHeight)
        this.originalHeight = this.refScrollShelvesRef?.clientHeight || this.refShelvesRef.clientHeight
      this.refShelvesRef.scrollLeft =
        this.refShelvesRef.scrollLeft * scaleDiff + (window.innerWidth / 2) * (newScale - scale)
      if (newScale <= 1 && this.originalHeight - this.refShelvesRef.clientHeight * newScale > 0) {
        if (this.refScrollShelvesRef) this.refScrollShelvesRef.style.height = this.widgetHeight * newScale + 20 + 'px'
        else {
          this.refShelvesRef.style.marginTop =
            String(-(this.originalHeight - this.refShelvesRef.clientHeight * newScale) / 2) + 'px'
        }
        this.clientHeight = this.refShelvesRef.clientHeight
      } else this.refShelvesRef.style.marginTop = '0px'
    }

    if (this.refShelvesRef && this.widgetWidth * newScale <= 1.05 * this.refShelvesRef.offsetWidth) {
      this.updateAnswer(answer.update('left', () => true).update('right', () => true))
    }
    // this.verticalScrolling =
    //   questionSchema.getIn(['coordinates', 'imageHeight']) * newScale >= this.refShelvesRef?.offsetHeight
    // this.horizontalScrolling =
    //   questionSchema.getIn(['coordinates', 'imageWidth']) * newScale >= 1.05 * this.refShelvesRef?.offsetWidth
    this.setState({ scale: newScale })
    this.onScroll()
  }

  unsubscribeFromMove() {
    if (this.touchMoveSubscription) {
      this.touchMoveSubscription.unsubscribe()
      this.touchMoveSubscription = null
      this.hypot = 0
    }
  }

  unsubscribeFromDrag() {
    if (this.dragSubscription) {
      this.dragSubscription.unsubscribe()
      this.dragSubscription = null
    }
  }

  onMouseUp() {
    setTimeout(() => {
      if (this.dragSubscription) this.unsubscribeFromDrag()
    }, 300)
  }

  onMouseDown(event) {
    const { scale } = this.state
    if (!this.handScale || scale <= 1) return
    const rect = this.refShelvesRef.getBoundingClientRect()
    const coords = { x: rect.x, y: rect.y }
    this.dragSubscription = drag(event, rect.x, rect.y).subscribe(moveUpdate => {
      this.refShelvesRef.scrollBy(coords.x - moveUpdate.x, coords.y - moveUpdate.y)
      coords.x = moveUpdate.x
      coords.y = moveUpdate.y
      if (moveUpdate.dragging) this.dragging = moveUpdate.dragging
      else
        setTimeout(() => {
          this.dragging = moveUpdate.dragging
        }, 200)
    })
  }

  onTouchStart(event) {
    const { selectedItem, answer } = this.state
    if (selectedItem) return
    this.touchMoveSubscription = resize(event).subscribe(moveUpdate => {
      const { scale } = this.state
      if (moveUpdate.hypot) {
        if (this.hypot)
          this.updateScale(Math.max(window.innerWidth / this.widgetWidth, (scale * moveUpdate.hypot) / this.hypot))
        if (window.innerWidth < this.widgetWidth) this.hypot = moveUpdate.hypot
      }
      if (!moveUpdate.scaling) {
        this.unsubscribeFromMove()
        this.hypot = 0

        const goalScale = this.widgetWidth > window.innerWidth ? window.innerWidth / this.widgetWidth : 1
        if (scale < goalScale) {
          const resize = newScale => {
            if (newScale < goalScale) {
              this.updateScale(newScale)
              setTimeout(() => resize(newScale + 0.02 > goalScale ? goalScale : newScale + 0.02), 10)
            } else this.updateScale(goalScale)
          }
          resize(scale + 0.02)
        } else {
          if (this.contentWidth * scale <= 1.05 * this.refShelvesRef?.offsetWidth)
            this.updateAnswer(answer.update('left', () => true).update('right', () => true))
        }
      }
    })
  }

  getContainer() {
    return this.refShelvesRef
  }

  renderVerticalScroll() {
    return (
      <div className={style.verticalScroll} ref={this.saveRef('VerticalScrollDiv')}>
        <div
          className={style.verticalscrollPointer}
          ref={this.saveRef('VerticalScrollPointer')}
          onTouchStart={this.onVerticalScrollTouchStart}
          onMouseDown={this.onVerticalScrollMouseDown}
        />
      </div>
    )
  }

  renderHorizontalScroll() {
    return (
      <div className={style.horizontalScroll} ref={this.saveRef('HorizontalScrollDiv')}>
        <div
          className={style.horizontalscrollPointer}
          ref={this.saveRef('HorizontalScrollPointer')}
          onTouchStart={this.onHorizontalScrollTouchStart}
          onMouseDown={this.onHorizontalScrollMouseDown}
        />
      </div>
    )
  }

  calculateVerticalScrolling(dragUpdate) {
    const { showCart, scale } = this.state
    if (!showCart && this.refShelvesRef) {
      const x = dragUpdate
        ? Math.min(
            this.refVerticalScrollDiv.clientHeight - this.refVerticalScrollPointer.clientHeight / 2,
            dragUpdate.y - this.refVerticalScrollPointer.clientHeight / 2
          )
        : this.refVerticalScrollDiv.clientHeight * Math.random()
      this.verticalScrollPercent =
        x / (this.refVerticalScrollDiv.clientHeight - this.refVerticalScrollPointer.clientHeight)
      this.refShelvesRef.scrollTop =
        this.verticalScrollPercent * (this.widgetHeight * scale - this.refShelvesRef.offsetHeight)
    }
    // this.refScrollPointer.style.left =
    //   this.scrollPercent * (this.refScrollDiv.clientWidth - this.refScrollPointer.clientWidth) + 'px'
  }

  onVerticalScrollTouchStart(event) {
    return 1 == event.touches.length ? this.onVerticalScrollMouseDown(processTouchEvent(event)) : false
  }

  onVerticalScrollMouseDown(event) {
    const targetX = this.refVerticalScrollPointer.offsetLeft + this.refVerticalScrollPointer.offsetWidth / 2
    const targetY = this.refVerticalScrollPointer.offsetTop + this.refVerticalScrollPointer.offsetHeight / 2
    this.verticalSubcscription = drag(event, targetX, targetY).subscribe(dragUpdate => {
      this.calculateVerticalScrolling(dragUpdate)
    })
  }

  calculateHorizontalScrolling(dragUpdate) {
    const { showCart, scale } = this.state
    if (!showCart && this.refShelvesRef) {
      const x = dragUpdate
        ? Math.min(
            this.refHorizontalScrollDiv.clientWidth - this.refHorizontalScrollPointer.clientWidth / 2,
            dragUpdate.x - this.refHorizontalScrollPointer.clientWidth / 2
          )
        : this.refHorizontalScrollDiv.clientWidth * Math.random()
      this.horizontalScrollPercent =
        x / (this.refHorizontalScrollDiv.clientWidth - this.refHorizontalScrollPointer.clientWidth)
      this.refShelvesRef.scrollLeft =
        this.horizontalScrollPercent * (this.contentWidth * scale - this.refShelvesRef.offsetWidth)
    }
    // this.refScrollPointer.style.left =
    //   this.scrollPercent * (this.refScrollDiv.clientWidth - this.refScrollPointer.clientWidth) + 'px'
  }

  onHorizontalScrollTouchStart(event) {
    return 1 == event.touches.length ? this.onHorizontalScrollMouseDown(processTouchEvent(event)) : false
  }

  onHorizontalScrollMouseDown(event) {
    const targetX = this.refHorizontalScrollPointer.offsetLeft + this.refHorizontalScrollPointer.offsetWidth / 2
    const targetY = this.refHorizontalScrollPointer.offsetTop + this.refHorizontalScrollPointer.offsetHeight / 2
    this.horizontallSubcscription = drag(event, targetX, targetY).subscribe(dragUpdate => {
      this.calculateHorizontalScrolling(dragUpdate)
    })
  }

  renderShelfContent() {
    const { questionSchema, theme, emulatedMobile, onRender, generateImageHook, generateImage } = this.props
    const { selectedItem, answer, goods, cartCount, scale, hideContent, hover, titleHeight } = this.state
    const fullscreen = questionSchema.get('fullscreen') && !this.generateImage
    // pallet multi-section column count (1..3); default 1 for legacy or non-pallet.
    const palletSectionsCount = Math.max(1, Math.min(3, questionSchema.get('pallet_sections_count') || 1))
    // single source of the rendered (cropped) content width; see this.contentWidth in the constructor
    const containerWidth = this.contentWidth

    const statScroll = generateImage && this.maxWidth / this.widgetWidth < 1

    let currentShelvesCount = 0
    let currentBlocksWidth = 0
    const isMobile = 'mobile' == theme

    return (
      <Fragment>
        <div
          onTouchStart={this.onTouchStart}
          onMouseDown={this.onMouseDown}
          onMouseUp={this.onMouseUp}
          // style={{ position: 'relative' }}
          data-testid="SW-SH-Content"
        >
          {this.shelvesSettings.fridge ? (
            <div
              ref={this.saveRef('ShelvesRef')}
              className={style.shelfvesRef}
              style={{
                overflow: this.handScale && scale > 1 ? 'scroll' : 'inherit'
              }}
            >
              <Fridge
                questionSchema={questionSchema}
                widthFactor={this.widthFactor}
                doors={!isMobile && !selectedItem && !this.generateImage}
                mobile={isMobile}
                answers={this.answers}
                fullscreen={fullscreen}
                width={this.shelvesSettings.discrete ? this.width : this.widgetWidth}
                takenGoods={goods}
                cartCount={cartCount}
                externalHover={hover}
                onHovered={this.onHover}
                onRender={onRender}
                emulatedMobile={emulatedMobile}
                onProductClick={this.onProductClick}
                double={true}
                answersImages={this.answersImages}
                scale={scale}
                margins={{
                  left: this.handScale ? (this.widgetWidth * (scale - 1)) / 2 : 'inherit',
                  top: this.handScale && scale > 1 ? (this.originalHeight * (scale - 1)) / 2 : 0
                }}
                generateImage={generateImageHook || this.generateImage}
                blockWidths={[0, this.shelfWidth]}
              />
            </div>
          ) : (
            <>
              {/* {this.refShelvesRef && isMobile && this.contentWidth * scale > 1.1 * this.refShelvesRef.offsetWidth && (
                <div className={shelfStyle.leftArrow} onClick={this.scrollToLeft} ref={this.saveRef('LeftArrow')}>
                  <i className="icon-aytmfd-new-prev" />{' '}
                </div>
              )} */}
              {this.horizontalScrolling &&
                questionSchema.getIn(['coordinates', 'imageWidth']) * scale >= 1.05 * this.refShelvesRef?.offsetWidth &&
                this.renderHorizontalScroll()}
              <div
                className={` ${style.scrollContainer} ${
                  shelfStyle[SETTINGS[questionSchema.get('store')][questionSchema.get('shelf_type')].styleClass]
                } ${shelfStyle.container} ${this.widgetWidth > MAX_WIDGET_WIDTH ? style.scrolling : ''} ${
                  hideContent ? style.hideContent : ''
                }`}
                ref={this.saveRef('ShelvesRef')}
                onScroll={this.onScroll}
                style={{
                  maxWidth: this.renderScrolling ? window.innerWidth : 'auto',
                  maxHeight: titleHeight ? window.innerHeight - titleHeight - 105 : 'auto',
                  overflow: 'scroll'
                }}
              >
                <div ref={this.saveRef('ScrollShelvesRef')} className={style.scrollShelvesRef}>
                  <div
                    className={`${style.shelvesContainer}  ${
                      shelfStyle[SETTINGS[questionSchema.get('store')][questionSchema.get('shelf_type')].styleClass]
                    }`}
                    style={{
                      width: this.handScale ? containerWidth : containerWidth * scale,
                      transform: 'scale(' + (statScroll ? this.maxWidth / this.widgetWidth : scale) + ')',
                      marginLeft: this.handScale
                        ? (this.widgetWidth * (scale - 1)) / 2
                        : statScroll
                          ? (-this.widgetWidth + this.maxWidth) / 2
                          : 'auto',
                      marginTop: this.handScale && scale > 1 ? (this.originalHeight * (scale - 1)) / 2 : 0,
                      marginBottom: -(this.handScale && scale > 1 ? (this.originalHeight * (scale - 1)) / 2 : 0)
                    }}
                  >
                    {!isMobile && (
                      <div
                        className={` ${hover && questionSchema.get('blur') ? style.blurred : ''} ${
                          shelfStyle.dotsContainer
                        }`}
                      />
                    )}
                    {this.config.toArray().map((block, i) => {
                      const blockSize = this.config.getIn([i, 'shelves']).size
                      currentBlocksWidth += block.get('width')
                      currentShelvesCount += blockSize
                      return (
                        <div
                          className={`${style.shelfBlock} swidget-shelves-block ${
                            i == this.config.size - 1 ? shelfStyle.lastBlock : ''
                          }`}
                          key={'block' + i}
                        >
                          {isMobile && <div className={shelfStyle.dotsContainer} />}
                          <Shelves
                            questionSchema={questionSchema}
                            fullscreen={fullscreen}
                            scrolling={this.animateLayers}
                            getContainer={this.getContainer}
                            mobile={'mobile' == theme}
                            widthFactor={this.widthFactor}
                            width={(containerWidth * block.get('width')) / this.shelfWidth}
                            answers={this.answers}
                            cartCount={cartCount}
                            emulatedMobile={emulatedMobile}
                            takenGoods={goods}
                            onProductClick={this.onProductClick}
                            onHovered={this.onHover}
                            first={true}
                            palletSectionIndex={0}
                            palletSectionsCount={palletSectionsCount}
                            last={i == this.config.size - 1}
                            externalHover={hover}
                            answersImages={this.answersImages}
                            generateImage={generateImageHook || this.generateImage}
                            onRender={onRender}
                            config={this.config.getIn([i, 'shelves'])}
                            shelvesNumbers={[currentShelvesCount - blockSize, currentShelvesCount]}
                            blockWidths={[
                              currentBlocksWidth - block.get('width'),
                              (palletSectionsCount > 1
                                ? 2 * palletSectionsCount
                                : questionSchema.get('double_width')
                                  ? 4
                                  : 'pallet' == questionSchema.get('shelf_type')
                                    ? 2
                                    : 1) * this.shelfWidth
                            ]}
                          />
                        </div>
                      )
                    })}
                    {/* pallet multi-section: render sections 1..N-1 as full-width Shelves overlaid via container additionalX. */}
                    {palletSectionsCount > 1 &&
                      Array.from({ length: palletSectionsCount - 1 }, (_, idx) => idx + 1).map(sectionIdx => (
                        <Shelves
                          key={'palletSection' + sectionIdx}
                          questionSchema={questionSchema}
                          fullscreen={fullscreen}
                          scrolling={this.animateLayers}
                          getContainer={this.getContainer}
                          mobile={'mobile' == theme}
                          widthFactor={this.widthFactor}
                          width={this.widgetWidth}
                          emulatedMobile={emulatedMobile}
                          cartCount={cartCount}
                          answers={this.answers}
                          onRender={onRender}
                          config={this.config.getIn([0, 'shelves'])}
                          takenGoods={goods}
                          externalHover={hover}
                          answer={answer.get('answers')}
                          onProductClick={this.onProductClick}
                          onHovered={this.onHover}
                          palletSectionIndex={sectionIdx}
                          palletSectionsCount={palletSectionsCount}
                          answersImages={this.answersImages}
                          generateImage={generateImageHook || this.generateImage}
                          shelvesNumbers={[0, questionSchema.get('shelves_amount')]}
                          blockWidths={[0, 2 * palletSectionsCount * this.shelfWidth]}
                        />
                      ))}
                    {'pallet' !== questionSchema.get('shelf_type') && questionSchema.get('double_width') && (
                      <Shelves
                        questionSchema={questionSchema}
                        fullscreen={fullscreen}
                        scrolling={this.animateLayers}
                        getContainer={this.getContainer}
                        mobile={'mobile' == theme}
                        widthFactor={this.widthFactor}
                        width={this.widgetWidth}
                        emulatedMobile={emulatedMobile}
                        cartCount={cartCount}
                        answers={this.answers}
                        onRender={onRender}
                        config={this.config.getIn([0, 'shelves'])}
                        takenGoods={goods}
                        externalHover={hover}
                        answer={answer.get('answers')}
                        onProductClick={this.onProductClick}
                        onHovered={this.onHover}
                        answersImages={this.answersImages}
                        generateImage={generateImageHook || this.generateImage}
                        shelvesNumbers={[0, questionSchema.get('shelves_amount')]}
                        blockWidths={[0, 4 * this.shelfWidth]}
                      />
                    )}
                  </div>
                </div>
              </div>
              {/* {this.refShelvesRef && isMobile && this.contentWidth * scale > 1.05 * this.refShelvesRef.offsetWidth && (
                <div className={shelfStyle.rightArrow} onClick={this.scrollToRight} ref={this.saveRef('RightArrow')}>
                  <i className="icon-aytmfd-new-next" />{' '}
                </div>
              )} */}
            </>
          )}
          {selectedItem && (
            <ProductPopup
              questionSchema={questionSchema}
              item={selectedItem}
              answer={answer}
              enableMagnify={'mobile' != theme}
              emulatedMobile={emulatedMobile}
              onClosePopup={() => this.closeItemPopup()}
              onAction={this.addToCart}
              locale={this.locale}
              fullScreen={fullscreen}
              onPictureClick={this.onPictureClick}
              mobile={'mobile' != theme}
            />
          )}
        </div>
      </Fragment>
    )
  }

  showHideFullscreen() {
    this.setState({ closeFullscreen: !this.state.closeFullscreen })
    setTimeout(() => {
      if (this.refShelvesRef && window.innerHeight - 162 < this.refShelvesRef.offsetHeight) {
        this.refLinks.style.position = 'fixed'
        this.refFooter.style.position = 'fixed'
        // this.refLightBox.refLightBoxBackdrop.style.height =
        //   this.refLightBox.refLightBoxBackdrop.clientHeight - 90 + 'px'
      }
    }, 500)
  }

  renderContent() {
    const { questionSchema, theme, preview, emulatedMobile, questionTitle, innerWidth } = this.props
    const { showCart, selectedItem, answer, na, cartCount, closeFullscreen, scale, cartTotal } = this.state
    const answerItems = questionSchema.get('answers')
    const cart = questionSchema.get('shopping_cart') && !this.findability
    const fullscreen =
      questionSchema.get('fullscreen') &&
      'mobile' != theme &&
      'ecommerce' != questionSchema.get('store') &&
      !this.generateImage
    const shelfError = questionSchema.get('error')
    const store = questionSchema.get('store')
    const statScroll = this.generateImage && window.innerWidth / this.widgetWidth < this.context

    return 0 === answerItems.size ? (
      <Fragment>
        <div className={commonStyle['no-answers']} data-testid="SW-SH-NoAnswers">
          {this.locale.get('noAnswers')}
        </div>
      </Fragment>
    ) : (
      <Fragment>
        {shelfError && shelfError.size ? this.renderShelfError(shelfError.keySeq().first()) : ''}
        {!na && (cart || questionSchema.get('force_scroll')) && this.renderError()}
        {this.generateImage ? '' : this.renderLongError()}
        {showCart && !selectedItem && !fullscreen ? (
          <Cart
            questionSchema={questionSchema}
            answer={answer}
            fullHeight={selectedItem}
            onProductClick={this.showItemPopup}
            onQtyChange={this.selectQTY}
            onDelete={this.deleteFromCart}
            locale={this.locale}
            mobile={theme === 'mobile'}
          />
        ) : fullscreen && !closeFullscreen && !this.generateImage ? (
          <LightBox
            ref={this.saveRef('LightBox')}
            background="black"
            className={`rfd-ui-light-box ${style.hidePreviewButtons} ${style.fullsizedShelf}
            ${
              this.refLightBox && this.refLightBox.refLightBoxBackdrop.clientHeight > window.height
                ? style.topAlign
                : ''
            }`}
          >
            <div className={style.fullsizedContainer} style={{ maxWidth: this.contentWidth }}>
              <div>
                <h4
                  className={style.title}
                  id="swidget-question-header-text"
                  ref={this.saveRef('Title')}
                  data-testid="SW-SH-FSTitle"
                >
                  {questionTitle}
                </h4>
              </div>
              {showCart && !selectedItem && !na && (
                <div
                  className={`${style.fullscreenCart} ` + (!cartCount ? `${style.empty}` : ``)}
                  data-testid="SW-SH-FSCart"
                >
                  <Cart
                    questionSchema={questionSchema}
                    answer={answer}
                    fullHeight={selectedItem}
                    fullScreen={true}
                    onProductClick={this.showItemPopup}
                    onQtyChange={this.selectQTY}
                    onDelete={this.deleteFromCart}
                    locale={this.locale}
                    mobile={theme === 'mobile'}
                  />
                  {cart && !na && (
                    <Fragment>
                      <span
                        className={`${style.clear} ` + (!cartCount ? `${style.disabled}` : ``)}
                        onClick={this.clearCart}
                      >
                        {this.locale.getIn(['sh', 'clearCart'])}
                      </span>
                      <span className={style.back} onClick={this.showHideCart}>
                        {this.locale.getIn(['sh', 'backToStore'])}
                      </span>
                    </Fragment>
                  )}
                  <span className={style.closeButton} onClick={this.showHideCart} data-testid="SW-SH-FSClose">
                    <i className="icon-aytmfd-close" />
                  </span>
                </div>
              )}
              {this.renderError()}
              <div
                className={`${style.shelfContent} ${
                  na || (fullscreen && showCart && !selectedItem) ? style.disabledStore : ''
                }`}
                data-testid="SW-SH-Content"
              >
                {questionSchema.getIn(['coordinates', 'imageHeight']) * scale >=
                  1.05 * this.refShelvesRef?.offsetHeight &&
                  this.verticalScrolling &&
                  this.renderVerticalScroll()}
                {/*{questionSchema.getIn(['coordinates', 'imageWidth']) * scale >=*/}
                {/*  1.05 * this.refShelvesRef?.offsetWidth &&*/}
                {/*  this.horizontalScrolling &&*/}
                {/*  this.renderHorizontalScroll()}*/}
                {this.renderScrolling && (
                  <div
                    className={style.leftShadow}
                    ref={this.saveRef('LeftShadow')}
                    style={{
                      opacity: 0
                    }}
                    data-testid="SW-SH-LeftShadow"
                  />
                )}
                {this.renderShelfContent()}
                {this.renderScrolling && (
                  <div
                    className={style.rightShadow}
                    ref={this.saveRef('RightShadow')}
                    style={{
                      opacity: 1
                    }}
                    data-testid="SW-SH-RightShadow"
                  />
                )}
              </div>

              {fullscreen && preview && !selectedItem && (
                <div className={style.closeFullscreen} onClick={this.showHideFullscreen} data-testid="SW-SH-FSClose">
                  {' '}
                  <i className="icon-aytmfd-delete"></i>
                </div>
              )}
            </div>
            <div
              className={style.fullScreenLinks}
              ref={this.saveRef('Links')}
              style={{ maxWidth: this.contentWidth }}
              data-testid="SW-SH-FSLinks"
            >
              <ShelfFooter
                questionSchema={questionSchema}
                cartCount={cartCount}
                cartTotal={cartTotal}
                showCart={showCart}
                theme={theme}
                innerWidth={innerWidth}
                locale={this.locale}
                preview={preview}
                generateImage={this.generateImage}
                renderScrolling={this.renderScrolling}
                changeNA={this.changeNA}
                clearCart={this.clearCart}
                showHideCart={this.showHideCart}
                renderScroll={this.renderScroll}
                na={na}
                scale={scale}
                updateScale={this.updateScale}
                scaleButtonsRef={this.refScaleButtons}
              />
            </div>
            <div className={style.fullScreenFooter} ref={this.saveRef('Footer')}>
              {this.renderNext()}
            </div>
          </LightBox>
        ) : 'ecommerce' == store ? (
          <div className={` ${na ? style.disabledStore : ''}`}>
            {selectedItem ? (
              <EcommercePopup
                questionSchema={questionSchema}
                item={selectedItem}
                answer={answer}
                enableMagnify={'mobile' != theme}
                emulatedMobile={emulatedMobile}
                onClosePopup={() => this.closeItemPopup()}
                onAction={this.addToCart}
                locale={this.locale}
              />
            ) : (
              <Ecommerce
                questionSchema={questionSchema}
                mobile={'mobile' == theme}
                answers={this.answers}
                onAction={this.addProductToCart}
                answer={answer}
                locale={this.locale}
                onProductClick={this.onProductClick}
              />
            )}
          </div>
        ) : (
          <Fragment>
            {fullscreen && closeFullscreen ? (
              <div className={style.closedFullscreen} data-testid="SW-SH-FSClosed">
                <div className={style.closedFullscreenButton} onClick={this.showHideFullscreen}>
                  {this.locale.getIn(['sh', 'closedFullscreenLabel'])}
                </div>
              </div>
            ) : (
              <div className={`${style.shelfContent} ${na ? style.disabledStore : ''}`} data-testid="SW-SH-Content">
                {this.renderScrolling && !statScroll && (
                  <div className={style.leftShadow} ref={this.saveRef('LeftShadow')} />
                )}
                {this.verticalScrolling &&
                  questionSchema.getIn(['coordinates', 'imageHeight']) * scale >=
                    1.05 * this.refShelvesRef?.offsetHeight &&
                  this.renderVerticalScroll()}
                {this.renderShelfContent()}
                {this.renderScrolling && !statScroll && (
                  <div className={style.rightShadow} ref={this.saveRef('RightShadow')} />
                )}
              </div>
            )}
          </Fragment>
        )}
        {!fullscreen && !this.generateImage && (
          <ShelfFooter
            questionSchema={questionSchema}
            cartCount={cartCount}
            cartTotal={cartTotal}
            showCart={showCart}
            theme={theme}
            innerWidth={innerWidth}
            locale={this.locale}
            preview={preview}
            generateImage={this.generateImage}
            renderScrolling={this.renderScrolling}
            changeNA={this.changeNA}
            clearCart={this.clearCart}
            showHideCart={this.showHideCart}
            renderScroll={this.renderScroll}
            na={na}
            scale={scale}
            updateScale={this.updateScale}
            scaleButtonsRef={el => {
              this.refScaleButtons = el
            }}
          />
        )}
      </Fragment>
    )
  }

  renderDesktop() {
    const { accentColor, accentColorRGB, questionSchema } = this.props

    if (this.isIos) return this.renderMobile()

    return (
      <Fragment>
        <SHTheme accentColor={accentColor} accentColorRGB={accentColorRGB} />
        <div
          className={`${style.component} ${style.desktop} ${this.generateImage ? style.noMargin : ''}`}
          data-testid="SW-SH"
          style={{
            width:
              // isStatPage && false //&& this.widgetWidth > window.innerWidth
              //   ? this.widgetWidth
              //   :
              questionSchema.get('fullscreen') && !this.generateImage ? 600 : Math.min(this.maxWidth, this.widgetWidth)
          }}
        >
          {this.renderContent()}
        </div>
      </Fragment>
    )
  }

  noApp() {
    this.setState({ dontWantToApp: true })
  }

  yesApp() {
    const { appUrl, questionSchema, recheck } = this.props
    if (appUrl) {
      const redirectUrl =
        'https://swidget.page.link/?link=https://shelf.link/?' +
        encodeURIComponent(appUrl) +
        (this.isIos ? '&isi=1626134368&ibi=com.umongous.swidget&ius=swidget' : '&apn=com.umongous.swidget')

      const callback = () => {
        localStorage.setItem('aytmShelfPosition', parseInt(questionSchema.get('position'), 10) + 1)
        window.location.reload()
      }

      window.addEventListener('focus', callback)
      window.addEventListener('pageshow', callback)
      this.interval = setInterval(() => {
        recheck(callback)
      }, 1500)
      cookie.save('shelf_test_mobile', true)
      window.location.replace(redirectUrl)
    } else this.noApp()
  }

  renderAppScreen() {
    return (
      <LightBox>
        <div className={style.application}>
          <i className="icon-aytmfd-qshelf-ar"></i>
          <div
            className={style.appText}
            dangerouslySetInnerHTML={{
              __html: this.locale.getIn(['sh', 'application', this.isIos ? 'iosText' : 'androidText'])
            }}
          ></div>
          <div className={style.appButtons}>
            <Button
              label={this.locale.getIn(['sh', 'application', 'buttonYes'])}
              className={style.button}
              onClick={this.yesApp}
            />
            <Button
              label={this.locale.getIn(['sh', 'application', 'buttonNo'])}
              className={style.button}
              onClick={this.noApp}
            />
          </div>
        </div>
      </LightBox>
    )
  }

  renderMobile() {
    const { dontWantToApp } = this.state
    const { questionSchema } = this.props
    return (
      <div className={`${style.component} ${style.mobile}`} data-testid="SW-SH">
        {questionSchema.get('enable_app') && !questionSchema.get('preview')
          ? dontWantToApp
            ? this.renderContent()
            : this.renderAppScreen()
          : this.renderContent()}
      </div>
    )
  }
}
